"use client"

import type { HTMLAttributes } from "react"

import { cn } from "../lib/cn"
import { gapClasses, type Gap } from "./layout"

type RowProps = HTMLAttributes<HTMLDivElement> & {
  gap?: Gap
  align?: "start" | "center" | "end" | "stretch" | "baseline"
  justify?: "start" | "center" | "end" | "between"
  wrap?: boolean
}

export function Row({ gap = "sm", align = "center", justify, wrap, className, ...props }: RowProps) {
  return <div className={cn("flex", gapClasses[gap], { "items-start": align === "start", "items-center": align === "center", "items-end": align === "end", "items-stretch": align === "stretch", "items-baseline": align === "baseline", "justify-start": justify === "start", "justify-center": justify === "center", "justify-end": justify === "end", "justify-between": justify === "between", "flex-wrap": wrap }, className)} {...props} />
}
